import { render, staticRenderFns } from "./slider-component.vue?vue&type=template&id=3493f51f"
import script from "./slider-component.vue?vue&type=script&lang=js"
export * from "./slider-component.vue?vue&type=script&lang=js"
import style0 from "./slider-component.vue?vue&type=style&index=0&id=3493f51f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports